<fuse-widget  class="widget p-0" fxLayout="column" fxLayoutAlign="space-between center" fxFlex="100">

    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2 test">
        
      <!--Uncomment the mat-toolbar section below to display a title for the search widget-->
      <!-- <mat-toolbar class="px-16 py-12 border-bottom mat-accent-bg title-bar" fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="row" fxLayoutAlign="start center">
              <div class="h3 title pr-4">Search</div>
          </div>
      </mat-toolbar> -->

      <div fxLayout="row" fxLayoutAlign="stretch center" class="px-16 py-16">
        <button mat-button class="mat-icon-button" (click)="search()">
          <mat-icon>search</mat-icon>
        </button>
        <mat-form-field class="full-width" fxFlex=100>
          <input matInput placeholder="Search" [(ngModel)]="value" (input)=input(value)>
          <button mat-icon-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

    </div>
    <!-- / Front -->

</fuse-widget>